import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTCoreABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { CollectionName, RarityMapping, TypeMapping } from "src/utils/knight";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_CORE_ADDRESS } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) contractReader = new web3Reader.eth.Contract(ABI, NFT_CORE_ADDRESS);
  if (!contractReader) throw new Error("Failed to create nft-core contract reader");
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) contractSender = new web3Sender.eth.Contract(ABI, NFT_CORE_ADDRESS);
  if (!contractSender) throw new Error("Failed to create nft-core contract sender");
  return contractSender;
}

async function getBalance(ownerAddress) {
  const balance = await getContractReader().methods.balanceOf(ownerAddress).call();
  return parseInt(balance);
}

async function getTokenMetadata(tokenId) {
  const res = await getContractReader().methods.getTokenMetadata(tokenId).call();
  return {
    isOpened: Boolean(res.isOpened),
    rarity: RarityMapping[parseInt(res.tokenRarity) - 1],
    type: TypeMapping[parseInt(res.tokenType) - 1],
    set: CollectionName[parseInt(res.collectionId) - 1],
    exp: parseInt(res.experiencePoint),
  };
}

async function getUniqueTokenMetadata(tokenId) {
  const res = await getContractReader().methods.getUniqueTokenMetadata(tokenId).call();
  return res;
}

async function approveForAll(dispatch, operatorAddress, accountAddress) {
  const emit = getContractSender().methods.setApprovalForAll(operatorAddress, true).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Approve");
  await emit;
}

async function isApprovedForAll(ownerAddress, operatorAddress, accountAddress) {
  return await getContractReader()
    .methods.isApprovedForAll(ownerAddress, operatorAddress)
    .call({ from: accountAddress });
}

async function getTotalSupply() {
  const res = await getContractReader().methods.totalSupply().call();
  return parseInt(res);
}

async function transfer(dispatch, to, tokenId, accountAddress) {
  const emit = getContractSender().methods.transferFrom(accountAddress, to, tokenId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Transfer");
  await emit;
}

export default {
  ABI,
  ADDRESS: NFT_CORE_ADDRESS,
  getBalance,
  getTokenMetadata,
  getUniqueTokenMetadata,
  approveForAll,
  isApprovedForAll,
  getTotalSupply,
  transfer,
};
